export function getRandomPrompts(prompts, count) {
    const shuffledPrompts = prompts.sort(() => Math.random() - 0.5);
    const selectedPrompts = shuffledPrompts.slice(0, count);
  
    return selectedPrompts;
  }

  